import { AxiosResponse } from 'axios';
import { HttpResponse } from 'shell/models/http-response';
import { Operator } from 'shell/models/operator';
import { OperatorForm } from 'system/view-models/operator';
import { AnprOperation, AuthorizationsList } from 'shell/models/feature';
import { DateTime } from 'luxon';

const createAuthorizationsList = (
  response: AxiosResponse<HttpResponse<Operator>>
): Array<AuthorizationsList> => {
  const data = response.data.payload || {};

  const list = data.tipoFeatureAuthOperatoreList || [];
  return list.map((item) => {
    const nameTipofeature = item?.descrizioneAutorizzazione || '';
    const idTipofeature = item?.key?.codiceFeature || '';
    const descriptionFutureValue = item?.descrizioneValoreFeatureAuthOpe;
    const value = item?.valoreFeatureAuthOpe;

    return {
      id: idTipofeature,
      type: nameTipofeature,
      value: `${value} - ${descriptionFutureValue}`,
    };
  });
};

export const transformerOperator = (
  response: AxiosResponse<HttpResponse<Operator>>
): OperatorForm => {
  const data = response.data.payload || {};

  const res: OperatorForm = {
    operator: {
      institution: data?.key.codiceEnte || '',
      institutionType: data?.tipoEnte || '',
      lastUpdate: data?.note || '',
      active: false,
      code: data?.key?.codiceOperatore || '',
      extCode: data?.userEstesa || '',
      codAna: data?.codana?.toString() || '',
      name: data?.cognomeNome || '',
      service: data?.codiceServizio || '',
      qualification: data?.qualifica?.key.codiceQualifica || '',
      typeOperator: data?.tipoOperatore || '',
      password: data?.password || '',
      fiscalCode: data?.codiceFiscale || '',
      email: data?.email || '',
      terminal: data?.operatoreEsteso?.terminale || '',
      operatorCode: '',
      profile: (data?.operatoreProfiloList || [])[0]?.key?.codiceProfilo || '',
      passwordExpiration: null,
      authorizationExpiration: data?.dataScadenza ? DateTime.fromISO(data?.dataScadenza) : null,
      cancellationDate: data?.dataCancellazione ? DateTime.fromISO(data?.dataCancellazione) : null,
      lastLoginDateTime: data?.timestampUltimoAccesso
        ? DateTime.fromISO(data?.timestampUltimoAccesso)
        : null,
    },
    feature: {
      anpr: data?.anpr as unknown as AnprOperation,
      authorizationsList: createAuthorizationsList(response) as Array<AuthorizationsList>,
    },
    anpr: {
      stationIdAnpr:
        data.operatoreAnpr?.idPostazione || data.operatoreAnpr?.certPostazione?.codicePostazioneAnpr
          ? {
              id: data.operatoreAnpr?.idPostazione || undefined,
              description: data.operatoreAnpr?.certPostazione?.codicePostazioneAnpr || '',
            }
          : undefined,
      anprOperatorCode: data.operatoreAnpr?.codiceAnpr || '',
      certificateName: data.operatoreAnpr?.certPostazione?.className || '',
      stationId: data.operatoreAnpr?.idPostazione?.toString() || '',
      validityStart: data.operatoreAnpr?.dataInizioValidita
        ? DateTime.fromISO(data.operatoreAnpr?.dataInizioValidita)
        : null,
      validityEnd: data.operatoreAnpr?.dataFineValidita
        ? DateTime.fromISO(data.operatoreAnpr?.dataFineValidita)
        : null,
      validityStartCertificate: data.operatoreAnpr?.dataInizioValidita
        ? DateTime.fromISO(data.operatoreAnpr?.dataInizioValidita)
        : null,
      validityEndCertificate: data.operatoreAnpr?.dataFineValidita
        ? DateTime.fromISO(data.operatoreAnpr?.dataFineValidita)
        : null,
    },
    services: {
      page: 0,
      rowsPerPage: 10,
      servicesList: (data.operatoreServizioList || []).map(
        (service) => service.key?.codiceServizio
      ),
    },
  };

  return res;
};
